import type { SxProps, Theme } from '@mui/material/styles';

/**
 * Shared `sx` for tiny map control labels (e.g. compass direction, control button text).
 *
 * We keep this as ad-hoc `sx` instead of a Typography variant or theme `h4` / small-caps
 * because:
 * - The map chrome needs a fixed ~8.5px cap height, not the rem-based heading scale.
 * - `textTransform: 'uppercase'` replaces the old `all-small-caps` theme hack, which
 *   avoided `fontVariant: small-caps` on iOS due to scaling/rendering quirks in WebView.
 *
 * Use theme typography variants for normal UI; reserve this only for dense map controls.
 */
export const microCapsLabelSx: SxProps<Theme> = {
  fontSize: 8.5,
  fontWeight: 500,
  textTransform: 'uppercase',
  lineHeight: '16px',
  paddingTop: '2px',
  marginBottom: '-2px',
};
